// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 管理员登录 使用用户名密码登录，如启用 TOTP 需提供验证码 POST /api/admin/auth/login */
export async function loginApiAdminAuthLoginPost(
  body: API.AdminLoginRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResponseAdminLoginResponse_>("/api/admin/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取当前管理员信息 获取当前登录管理员的信息 GET /api/admin/auth/me */
export async function getMeApiAdminAuthMeGet(options?: { [key: string]: any }) {
  return request<API.ApiResponseAdminInfo_>("/api/admin/auth/me", {
    method: "GET",
    ...(options || {}),
  });
}

/** 禁用 TOTP 验证密码后禁用两步验证 POST /api/admin/auth/totp/disable */
export async function totpDisableApiAdminAuthTotpDisablePost(
  body: API.TOTPDisableRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResponseNoneType_>("/api/admin/auth/totp/disable", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 启用 TOTP 验证 TOTP 码并启用两步验证 POST /api/admin/auth/totp/enable */
export async function totpEnableApiAdminAuthTotpEnablePost(
  body: API.TOTPEnableRequest,
  options?: { [key: string]: any }
) {
  return request<API.ApiResponseNoneType_>("/api/admin/auth/totp/enable", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取 TOTP 设置信息 生成 TOTP 密钥和 otpauth URI，用于绑定验证器 POST /api/admin/auth/totp/setup */
export async function totpSetupApiAdminAuthTotpSetupPost(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponseTOTPSetupResponse_>(
    "/api/admin/auth/totp/setup",
    {
      method: "POST",
      ...(options || {}),
    }
  );
}
